import styles from "./styles.module.css";
import { UserContext } from "../../context/UserContext";
import { Bars } from "react-loader-spinner";
import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import logout from "../../services/logout";

const Logout = () => {
  const {
    token,
    setExp,
    setAuthTime,
    setToken,
    setEmail,
    setName,
  } = useContext(UserContext);
  const navigate = useNavigate();

  useEffect(() => {
    const fazerLogout = async () => {
      await logout(token).catch((err) => {
        console.log(err);
      });
      setExp(0);
      setAuthTime(0);
      setToken("");
      setEmail("");
      setName("");
      navigate("/");
    };
    fazerLogout();
  }, []);

  return (
    <div className={styles.loading}>
      <Bars
        height="80"
        width="80"
        color="#172554"
        ariaLabel="bars-loading"
        wrapperStyle={{}}
        wrapperClass=""
        visible={true}
      />
    </div>
  );
};

export default Logout;